import { isCentralHost, isTenancyFrontendEnabled } from "@/utils/hostname";

function normalizeRoles(raw) {
  if (!Array.isArray(raw)) return [];
  return raw.map((r) => (typeof r === "string" ? r : r?.name)).filter(Boolean);
}

export function resolveHomeRoute(auth) {
  if (!auth?.isAuthenticated) {
    if (isTenancyFrontendEnabled() && isCentralHost()) {
      return "/";
    }
    return "/login";
  }

  const roles = normalizeRoles(auth.user?.roles);
  const isSuperAdmin = roles.includes("SuperAdmin");
  const isAdmin = roles.includes("Admin");
  const isHr = roles.includes("Hr") || roles.includes("HR");
  const isEmployee = roles.includes("Employee");
  const isClient = roles.includes("Client");

  if (isSuperAdmin) {
    return "/super-admin/dashboard";
  }

  if (
    isClient &&
    !isEmployee &&
    !isAdmin &&
    !isHr
  ) {
    return "/crm/clients";
  }

  if (isEmployee && !isAdmin && !isHr) {
    return "/dashboard/employee-dashboard";
  }

  return "/dashboard/admin-dashboard";
}

export function resolveHomeLabel(auth) {
  if (!auth?.isAuthenticated) {
    return isTenancyFrontendEnabled() && isCentralHost()
      ? "Back to home"
      : "Back to sign in";
  }

  const roles = normalizeRoles(auth.user?.roles);
  if (roles.includes("SuperAdmin")) {
    return "Back to platform dashboard";
  }

  return "Back to dashboard";
}

export function isErrorPageRoute(to) {
  return [
    "error-404",
    "not-found",
    "error-500",
    "lock-screen",
    "workspace-not-found",
  ].includes(to?.name);
}
